import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import type {PendingReturnActionId} from '@/consts/pendingReturnActionIds';
import {setPendingReturnActionId} from '@/state/slices/globalSlice';

type ExternalLinkRedirectHandler = (() => void | Promise<void>) | undefined;

const usePendingReturnActionRedirect = (
    actionId: PendingReturnActionId,
    redirectToExternalLink: ExternalLinkRedirectHandler
) => {
    const dispatch = useDispatch();

    return useCallback(() => {
        if (typeof redirectToExternalLink !== 'function') return;

        dispatch(setPendingReturnActionId(actionId));
        redirectToExternalLink();
    }, [actionId, dispatch, redirectToExternalLink]);
};

export default usePendingReturnActionRedirect;
